module.exports = __webpack_public_path__ + "static/media/digital.98ccafaa.png";